module.exports = __webpack_public_path__ + "img/dotIcon.ccc5a6f4.svg";